<template>
  <transition name="cube-picker-fade">
    <cube-popup
      v-show="visible"
      ref="myModal"
      type="modal"
      :center="true"
      :mask-closable="maskClosable || true"
      position="center"
      @touchmove.prevent
      @mask-click="maskClick"
    >
      <transition name="cube-picker-move">
        <div
          v-show="visible"
          class="cube-picker-panel cube-safe-area-pb"
          @click.stop
        >
          <div class="cube-picker-choose">
            <div class="cube-picker-title-group">
              <h1
                class="cube-picker-title"
                v-html="title"
              />
              <h2
                v-if="subtitle"
                class="cube-picker-subtitle"
                v-html="subtitle"
              />
            </div>
          </div>

          <div class="cube-picker-content">
            <div
              ref="wrapper"
              class="wrapper"
            >
              <slot name="content" />
            </div>
          </div>

          <div
            v-if="footer"
            class="cube-picker-footer footer"
          >
            <cube-button
              class="cancel-btn"
              @click="cancel"
            >
              {{ _cancelTxt }}
            </cube-button>
            <cube-button
              class="confirm-btn"
              type="submit"
              @click="confirm"
            >
              {{ _confirmTxt }}
            </cube-button>
          </div>
        </div>
      </transition>
    </cube-popup>
  </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    cancelTxt: {
      type: String,
      default: ''
    },
    confirmTxt: {
      type: String,
      default: ''
    },
    footer: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    _cancelTxt () {
      return this.cancelTxt || this.$t('message["896"]')
    },
    _confirmTxt () {
      return this.confirmTxt || this.$t('message["915"]')
    }
  },
  methods: {
    maskClick () {
      this.maskClosable && this.cancel()
    },
    hide () {
      this.$emit('update:visible', false)
    },
    cancel () {
      this.hide()
      this.$emit('cancel')
    },
    confirm () {
      this.hide()
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cube-picker-choose {
  height: auto;
}
::v-deep .cube-picker-content {
  top: 12px;
  border-radius: 4px;
}
::v-deep .cube-picker-title-group {
  padding: 12px;
}
::v-deep .cube-picker-title {
  font-size: 14px;
}
.cube-picker-footer ::v-deep,
.footer ::v-deep {
  margin-top: 16px;
  height: 50px;
  line-height: 50px;
  border-top: solid 1px #dbdbdb;
  .cube-form-group-content {
    display: flex;
    justify-content: space-between;
  }
  .cube-btn,
  .btn {
    flex: 1;
    // width: 50%;
    padding: 0;
    color: $gray2;
    background-color: #fff;
    border-radius: 0;
    &:first-child {
      border-right: solid 1px #dbdbdb;
    }
    &.confirm-btn {
      color: $primary-color;
    }
  }
}
</style>
